import { Subject } from "rxjs";
import { OnDestroy } from "@angular/core";

export class BaseComponent implements OnDestroy
{
    protected unsubscribe$ = new Subject();

    public GetServices() : Array<any> {
        //TODO : read services from session storage
        return null;
    }

    public GetGrants() : Array<any> {
        return null;
    }

    public HasGrant(serviceName : string , grantName : string) : boolean {
        return false;
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}